var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from './../../services/user.service';
import { AuthService } from 'app/services/auth.service';
import { PaneHeaderService } from 'app/services/pane-header.service';
import { TooltipHelpService } from 'app/services/tooltip-help.service';
import { PopoutModalService } from 'app/services/popout-modal.service';
import { ActivityService } from 'app/services/activity.service';
import { LayerService } from 'app/services/layer.service';
import { MainDataService } from 'app/services/main-data.service';
import { LayerQcService } from 'app/services/layer-qc.service';
import { MainDataMapService } from 'app/services/main-data-map.service';
import { CommonModalService } from 'app/services/common-modal.service';
import { TestLayerSelectComponent } from '../modal/test-layer-select/test-layer-select.component';
import { CommonFunctionService } from 'app/services/common-function.service';
import { FeatTransactionLogComponent } from 'app/components/feat-transaction-log/feat-transaction-log.component';
import { TransactionLogService } from 'app/services/transaction-log.service';
import { ResolutionCenterService } from 'app/services/resolution-center.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { ClearService } from 'app/services/clear.service';
import { QcLayerSelectModalComponent } from '../modal/qc-layer-select-modal/qc-layer-select-modal.component';
import { AdminService } from 'app/services/admin.service';
import { FishboneService } from 'app/services/fishbone.service';
import { FeatReferenceDocumentComponent } from '../feat-reference-document/feat-reference-document.component';
import { BookmarkService } from 'app/services/bookmark.service';
var PaneHeaderComponent = /** @class */ (function () {
    function PaneHeaderComponent(router, cdRef, authService, activityService, adminService, attrIndexService, bookmarkService, clearService, commonService, fishboneService, layerService, qcService, mainDataService, mapService, modalService, paneHeaderService, popoutModalService, resolutionCenterService, tooltipHelpService, userService, transactionLogService) {
        var _this = this;
        this.router = router;
        this.cdRef = cdRef;
        this.authService = authService;
        this.activityService = activityService;
        this.adminService = adminService;
        this.attrIndexService = attrIndexService;
        this.bookmarkService = bookmarkService;
        this.clearService = clearService;
        this.commonService = commonService;
        this.fishboneService = fishboneService;
        this.layerService = layerService;
        this.qcService = qcService;
        this.mainDataService = mainDataService;
        this.mapService = mapService;
        this.modalService = modalService;
        this.paneHeaderService = paneHeaderService;
        this.popoutModalService = popoutModalService;
        this.resolutionCenterService = resolutionCenterService;
        this.tooltipHelpService = tooltipHelpService;
        this.userService = userService;
        this.transactionLogService = transactionLogService;
        this.longTransactionClass = '';
        this.contentMenus = [
            {
                key: 'home',
                label: 'Dashboard',
                navigateCommands: ['/azgiv/dashboard']
            },
            {
                key: 'live',
                label: 'Live Layers',
                hasSchemaMenu: true,
                hasMapFilter: true,
                navigateCommands: ['/azgiv/layers/live-layers']
            }, {
                key: 'report',
                label: 'Analysis',
                hasSchemaMenu: true,
                hasMapFilter: true,
                navigateCommands: ['/azgiv/layers/reports']
            }, {
                key: 'published',
                label: 'Published Layers',
                hasSchemaMenu: true,
                hasMapFilter: true,
                navigateCommands: ['/azgiv/layers/published-layers']
            }
        ];
        this.modelList = [{
                label: 'All',
                value: ''
            }, {
                label: 'NextGen',
                value: 'N'
            }, {
                label: 'Legacy',
                value: 'L'
            }];
        this.hasModelMenu = false;
        this.userMenu = [
            {
                label: 'UserName',
                key: 'user',
            }, {
                label: 'Sign out',
                key: 'logout',
                className: 'glyphicons glyphicons-log-out'
            }
        ];
        this.onClickRestoreLayers = function () { return __awaiter(_this, void 0, void 0, function () {
            var spinnerId, layers, data, rsp, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        spinnerId = this.commonService.getRandomId();
                        this.commonService.setLoadingSpinner(true, spinnerId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        return [4 /*yield*/, this.layerService.getTestLayerList()];
                    case 2:
                        layers = _a.sent();
                        data = {
                            layers: layers
                        };
                        return [4 /*yield*/, this.modalService.openModalWindow(TestLayerSelectComponent, {
                                maxHeight: '90%',
                                minWidth: '380px',
                                data: data
                            })];
                    case 3:
                        rsp = _a.sent();
                        if (!(rsp && rsp.layerIds)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.layerService.publishLayers(rsp.layerIds, true)];
                    case 4:
                        _a.sent();
                        // reload
                        location.reload();
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        err_1 = _a.sent();
                        console.log(err_1);
                        return [3 /*break*/, 7];
                    case 7:
                        this.commonService.setLoadingSpinner(false, spinnerId);
                        return [2 /*return*/];
                }
            });
        }); };
        this.onClickQcLayers = function () { return __awaiter(_this, void 0, void 0, function () {
            var layers, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        layers = this.layerService.layerListBS.getValue().layers.filter(function (l) { return l.id; }).map(function (l) {
                            return {
                                id: l.id,
                                label: l.category.nameShort
                            };
                        });
                        data = {
                            layers: layers
                        };
                        return [4 /*yield*/, this.modalService.openModalWindow(QcLayerSelectModalComponent, {
                                maxHeight: '600px',
                                minWidth: '380px',
                                data: data
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.onClickFishboneAnalysis = function () { return __awaiter(_this, void 0, void 0, function () {
            var exist;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.adminService.checkLongTransactions()];
                    case 1:
                        exist = _a.sent();
                        if (!exist) {
                            this.fishboneService.analyzeFishbone();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        this.onClickReferenceDoc = function () { return __awaiter(_this, void 0, void 0, function () {
            var spinnerId, list, err_2, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        spinnerId = this.commonService.getRandomId();
                        this.commonService.setLoadingSpinner(true, spinnerId);
                        list = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.bookmarkService.getMapBookmarks('HREF')];
                    case 2:
                        list = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        console.log(err_2);
                        return [3 /*break*/, 4];
                    case 4:
                        this.commonService.setLoadingSpinner(false, spinnerId);
                        data = {
                            bookmarkList: list
                        };
                        return [4 /*yield*/, this.modalService.openModalWindow(FeatReferenceDocumentComponent, {
                                height: '500px',
                                width: '700px',
                                data: data
                            })];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
    }
    ;
    ;
    PaneHeaderComponent.prototype.onChangeCustomer = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    PaneHeaderComponent.prototype.onChangeContentMenu = function (e) {
        console.log(e);
    };
    // This is for case when selectedContentMenu and route doesn't match, and clicking on menu won't trigger selectContentMenu
    PaneHeaderComponent.prototype.clickContentMenu = function (item) {
        if (this.stopClickEvent) {
            this.stopClickEvent = false;
            return;
        }
        console.log('click content menu');
        this.router.navigate(item.navigateCommands);
    };
    PaneHeaderComponent.prototype.selectContentMenu = function (item, skipNavigation, stopClickEvent) {
        return __awaiter(this, void 0, void 0, function () {
            var prev, isSuccessNavigate, schemas_1, schemaItem;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.stopClickEvent = stopClickEvent;
                        prev = this.selectedContentMenu;
                        this.selectedContentMenu = item;
                        if (!item) return [3 /*break*/, 2];
                        if (!(item.navigateCommands && !skipNavigation)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.router.navigate(item.navigateCommands)];
                    case 1:
                        isSuccessNavigate = _a.sent();
                        if (isSuccessNavigate || isSuccessNavigate === null) {
                            schemas_1 = this.mainDataService.schemasDefinedByBS.getValue();
                            if (schemas_1[item.key]) {
                                schemaItem = this.schemaDefinedByList.find(function (s) { return s.value === schemas_1[item.key].currentDefinedBy; });
                                this.selectSchema(schemaItem);
                            }
                        }
                        else if (isSuccessNavigate === false) { // If isSuccessNavigate is null, don't rollback to prev menu
                            setTimeout(function () {
                                _this.selectedContentMenu = prev;
                                _this.cdRef.detectChanges();
                            });
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    PaneHeaderComponent.prototype.onClickSettingMenu = function (item) {
        if (item.onClick) {
            item.onClick();
        }
        else if (item.navigateCommands) {
            this.router.navigate(item.navigateCommands);
        }
    };
    PaneHeaderComponent.prototype.selectSchema = function (item) {
        this.selectedSchema = item;
        var schemas = this.mainDataService.schemasDefinedByBS.getValue();
        schemas[this.selectedContentMenu.key].currentDefinedBy = item.value;
        this.mainDataService.schemasDefinedByBS.next(schemas);
        this.hasModelMenu = this.checkHasModelMenu();
    };
    PaneHeaderComponent.prototype.selectModel = function (item) {
        this.mainDataService.modelBS.next(item.value);
    };
    PaneHeaderComponent.prototype.clickUserMenuItem = function (item) {
        switch (item.key) {
            case 'user': break;
            case 'logout': this.clearService.logout();
        }
    };
    PaneHeaderComponent.prototype.clickTooltipHelp = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.qcService.qaRuleDetails) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.qcService.getAllQaRulesWithDetail()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.tooltipHelpService.isHelpOnBS.next(true);
                        this.openTooltipHelpPopout();
                        return [2 /*return*/];
                }
            });
        });
    };
    PaneHeaderComponent.prototype.clickTransactionLog = function () {
        return __awaiter(this, void 0, void 0, function () {
            var options, rsp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = {
                            height: '80%',
                            width: '550px'
                        };
                        return [4 /*yield*/, this.modalService.openModalWindow(FeatTransactionLogComponent, options)];
                    case 1:
                        rsp = _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PaneHeaderComponent.prototype.openTooltipHelpPopout = function () {
        var _this = this;
        var modalName = 'tooltipHelp';
        var modalData = {
            modalName: modalName,
            modalWindowName: 'Helps',
            onWindowClose: function (e) {
                _this.tooltipHelpService.isHelpOnBS.next(false);
            }
        };
        if (!this.popoutModalService.isPopoutOpen(modalName)) {
            this.popoutModalService.openPopoutModal(modalData);
        }
        else {
            this.popoutModalService.focusPopoutWindow(modalName);
        }
    };
    PaneHeaderComponent.prototype.checkHasModelMenu = function () {
        if (!this.selectedContentMenu || this.selectedContentMenu.key === 'home') {
            return false;
        }
        if (!this.selectedSchema || this.selectedSchema.value === 'local') {
            return false;
        }
        var selectedLayer = this.activityService.selectedLayerBS.getValue().layer;
        if (!selectedLayer || !selectedLayer.category) {
            return false;
        }
        if (selectedLayer.category.code !== this.attrIndexService.cateCodeAddress && selectedLayer.category.code !== this.attrIndexService.cateCodeCenterline) {
            return false;
        }
        else {
            return true;
        }
    };
    PaneHeaderComponent.prototype.onSelectAddress = function (e) {
        this.mapService.zoomToAddress(e);
    };
    PaneHeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        var isAdmin = this.userService.getUserInfo().isAdmin;
        this.settingsMenu = [
            {
                label: 'Users Manage',
                navigateCommands: ['/azgiv/config/users'],
                hidden: !isAdmin
            }, {
                label: 'Agency Profile',
                navigateCommands: ['/azgiv/config/agency-profile'],
                hidden: !isAdmin
            },
            {
                label: 'Sub Agencies',
                navigateCommands: ['/azgiv/config/sub-agencies'],
                hidden: !isAdmin
            },
            // {
            // 	label: 'Integrators',
            // 	navigateCommands: ['/azgiv/config/integrators'],
            // 	hidden: !isAdmin
            // },
            {
                label: 'NAG',
                navigateCommands: ['/azgiv/config/nag'],
                hidden: !isAdmin
            },
            // {
            // 	label: 'Restore Layers',
            // 	onClick: this.onClickRestoreLayers,
            // 	hidden: AppSettings.envName !== 'dev' && AppSettings.envName !== 'test'
            // },
            {
                label: 'QC Layers',
                onClick: this.onClickQcLayers,
                hidden: !isAdmin
            }, {
                label: 'Fishbone Analysis',
                onClick: this.onClickFishboneAnalysis,
                hidden: !isAdmin
            },
            {
                label: 'Reference Documents',
                onClick: this.onClickReferenceDoc,
                hidden: !isAdmin
            },
            {
                label: 'User Guide',
                navigateCommands: ['/azgiv/user-guide']
            },
        ];
        this.isAdminUser = this.userService.getUserInfo().isAdmin;
        this.agencyName = this.userService.getUserInfo().customerName;
        this.userName = this.userService.getUserInfo().userEmail;
        this.userRole = this.userService.getUserInfo().isAdmin ? 'Admin' : 'Operator'; // this.userService.userSubscription.role;
        this.customerType = this.userService.customerInfo.type;
        this.selectedCustomerSub = this.userService.selectedCustomer.subscribe(function (data) {
            console.log('selectedCustomer', data);
            _this.selectedCustomer = data;
            _this.selectedCustomerId = data ? data.id : null;
        });
        this.selfCustomerId = this.userService.customerInfo.id;
        this.agencyParentName = this.userService.customerInfo.parentName;
        //
        this.userMenu.find(function (i) { return i.key === 'user'; }).label = this.userRole + ': ' + this.userName;
        // schemaDefinedByList should be set before content menu subscription
        this.schemaDefinedByList = this.mainDataService.getSchemaDefinedBy();
        this.selectedSchema = this.schemaDefinedByList[0];
        this.contentMenuItemKeySub = this.mainDataService.contentMenuItemKeyBS.subscribe(function (data) {
            if (data) {
                _this.hasModelMenu = _this.checkHasModelMenu();
                var menu = _this.contentMenus.find(function (m) { return m.key === data; });
                if (menu !== _this.selectedContentMenu) {
                    _this.selectContentMenu(menu);
                }
            }
        });
        // this.selectViewFromCodeSub = this.contentLayerService.selectViewFromCode.subscribe(data => {
        // 	const item = this.viewList.find(v => v.key === data);
        // 	if (item) {
        // 		this.selectView(item);
        // 	}
        // });
        this.modelSub = this.mainDataService.modelBS.subscribe(function (data) {
            if (!_this.selectedModel || _this.selectedModel.value !== data) {
                _this.selectedModel = _this.modelList.find(function (m) { return m.value === data; });
            }
        });
        this.modelOptionSub = this.mainDataService.modelOptionBS.subscribe(function (data) {
            _this.showAllField = data.hasAllFields;
        });
        this.selectedLayerSub = this.activityService.selectedLayerBS.subscribe(function (data) {
            _this.hasModelMenu = _this.checkHasModelMenu();
        });
        this.changeCustomerSub = this.paneHeaderService.changeCustomerSubject.subscribe(function (data) {
            _this.selectedCustomerId = data;
        });
        this.transactionLogSub = this.transactionLogService.socketProcesses.subscribe(function (data) {
            if (data.length) {
                for (var i = 0; i < data.length; i++) {
                    if (data[i].status == 'Processing' || data[i].status == 'Preparing') {
                        // this.longTransactionClass = 'glyphicons loading-dots';
                        _this.longTransactionClass = 'spinner-arrow';
                        return;
                    }
                }
                // this.longTransactionClass = 'glyphicons glyphicons-more';
                _this.longTransactionClass = 'spinner-arrow-still';
            }
            else {
                _this.longTransactionClass = 'spinner-arrow-still';
            }
        });
    };
    PaneHeaderComponent.prototype.ngOnDestroy = function () {
        this.selectedCustomerSub.unsubscribe();
        this.contentMenuItemKeySub.unsubscribe();
        this.changeCustomerSub.unsubscribe();
        // this.selectViewFromCodeSub.unsubscribe();
        this.modelSub.unsubscribe();
        this.modelOptionSub.unsubscribe();
        this.selectedLayerSub.unsubscribe();
    };
    return PaneHeaderComponent;
}());
export { PaneHeaderComponent };
